// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Beautiful Design for Objective Modal */

/* Import Google Fonts for better typography */

/* CSS Variables for consistent theming */
:root {
  --primary-color: #F3903F;
  --primary-light: #fbbf24;
  --primary-dark: #d97706;
  --secondary-color: #F3903F;
  --accent-color: #F3903F;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --error-color: #ef4444;
  --info-color: #3b82f6;
  --text-primary: #1e293b;
  --text-secondary: #475569;
  --text-muted: #64748b;
  --icon-color: #64748b;
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --border-color: #e2e8f0;
  --border-light: #f1f5f9;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --gradient-primary: linear-gradient(135deg, #F3903F 0%, #d97706 100%);
  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #e67e22 100%);
  --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);
  --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  --gradient-info: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  --gradient-danger: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
}

/* Global Styles */
* {
  box-sizing: border-box;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: var(--text-primary);
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  min-height: 100vh;
  margin: 0;
  padding: 0;
}

.root {
  margin-top: 80px;
  padding: 1rem;
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

/* Header Section */
.roadmap-header {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
  text-align: center;
}

.roadmap-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-secondary);
  opacity: 0.9;
}

.roadmap-title {
  color: var(--text-primary);
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 1rem 0;
  background: var(--gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.roadmap-subtitle {
  color: var(--text-secondary);
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Compliance Frameworks Section */
.frameworks-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.frameworks-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-info);
  opacity: 0.9;
}

.frameworks-title {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.frameworks-title::before {
  content: '📋';
  font-size: 1.5rem;
}

.frameworks-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.framework-badge {
  background: var(--gradient-info);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.framework-badge:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* Timeline Section */
.timeline-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.timeline-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-success);
  opacity: 0.9;
}

.timeline-title {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.timeline-title::before {
  content: '📅';
  font-size: 1.5rem;
}

.timeline-loading {
  text-align: center;
  padding: 3rem 1rem;
}

.timeline-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid rgba(31, 124, 80, 0.2);
  border-top: 3px solid #1f7c50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

.timeline-loading-text {
  color: var(--text-secondary);
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

/* Objectives Section */
.objectives-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.objectives-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-warning);
  opacity: 0.9;
}

.objectives-title {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.objectives-title::before {
  content: '🎯';
  font-size: 1.5rem;
}

.objectives-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
  width: 100%;
}

/* Objective Card */
.objective-card {
  background: var(--bg-primary);
  border-radius: 12px;
  padding: 1.5rem;
  border: 2px solid var(--border-light);
  box-shadow: var(--shadow-sm);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.objective-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-secondary);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.objective-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-xl);
  border-color: var(--secondary-color);
}

.objective-card:hover::before {
  opacity: 1;
}

.objective-card.selected {
  border-color: var(--success-color);
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
}

.objective-card.selected::before {
  background: var(--gradient-success);
  opacity: 1;
}

.objective-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.objective-title {
  color: var(--text-primary);
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.4;
  flex: 1 1;
  margin-right: 1rem;
}

.priority-badge {
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.priority-badge.high {
  background: var(--gradient-danger);
  color: white;
}

.priority-badge.medium {
  background: var(--gradient-warning);
  color: white;
}

.objective-description {
  color: var(--text-secondary);
  font-size: 0.875rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.objective-meta {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-muted);
}

.meta-icon {
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.objective-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 1rem;
  border-top: 1px solid var(--border-light);
}

.objective-reference {
  color: var(--text-muted);
  font-size: 0.75rem;
  font-weight: 500;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-button {
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  border: 2px solid;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
}

.select-button.selected {
  background: var(--gradient-success);
  color: white;
  border-color: var(--success-color);
}

.select-button.selected:hover {
  transform: scale(1.05);
  box-shadow: var(--shadow-md);
}

.select-button:not(.selected) {
  background: transparent;
  color: var(--text-secondary);
  border-color: var(--border-color);
}

.select-button:not(.selected):hover {
  background: var(--bg-secondary);
  border-color: var(--secondary-color);
  color: var(--secondary-color);
}

/* Confirmation Section */
.confirmation-section {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border-light);
  position: relative;
  overflow: hidden;
}

.confirmation-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-success);
  opacity: 0.9;
}

.confirmation-checkbox {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.confirmation-checkbox:hover {
  background: var(--bg-secondary);
}

.confirmation-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  accent-color: var(--success-color);
  cursor: pointer;
}

.confirmation-checkbox label {
  color: var(--text-primary);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin: 0;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.build-roadmap-button {
  background: var(--gradient-success);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1.125rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--shadow-md);
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-width: 200px;
}

.build-roadmap-button:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow-xl);
  color: white;
  text-decoration: none;
}

.build-roadmap-button::before {
  content: '🚀';
  font-size: 1.25rem;
}

/* Loading States */
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  gap: 2rem;
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 3rem;
  box-shadow: var(--shadow-lg);
  width: 100%;
  text-align: center;
}

.loading-spinner {
  width: 64px;
  height: 64px;
  border: 4px solid rgba(31, 124, 80, 0.2);
  border-top: 4px solid #1f7c50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  box-shadow: var(--shadow-md);
}

.loading-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem 0;
}

.loading-subtitle {
  color: var(--text-secondary);
  font-size: 1.125rem;
  font-weight: 500;
  margin: 0;
  max-width: 400px;
  line-height: 1.6;
}

/* Empty State */
.empty-state {
  background: var(--bg-primary);
  border-radius: 16px;
  padding: 3rem 2rem;
  text-align: center;
  color: var(--text-muted);
  border: 2px dashed var(--border-color);
  width: 100%;
  box-shadow: var(--shadow-sm);
}

.empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-title {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.empty-description {
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* Apply animations */
.roadmap-header {
  animation: fadeInUp 0.6s ease-out;
}

.frameworks-section {
  animation: slideInLeft 0.6s ease-out 0.1s both;
}

.timeline-section {
  animation: slideInLeft 0.6s ease-out 0.2s both;
}

.objectives-section {
  animation: slideInLeft 0.6s ease-out 0.3s both;
}

.confirmation-section {
  animation: slideInLeft 0.6s ease-out 0.4s both;
}

.objective-card {
  animation: fadeInUp 0.6s ease-out;
}

/* Enhanced Hover Effects */
.objective-card:hover .priority-badge {
  animation: pulse 0.6s ease-in-out;
}

.framework-badge:hover {
  animation: pulse 0.6s ease-in-out;
}

/* Responsive Design */
@media (max-width: 768px) {
  .root {
    margin-top: 60px;
    padding: 0.5rem;
  }
  
  .roadmap-header {
    padding: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .roadmap-title {
    font-size: 2rem;
  }
  
  .roadmap-subtitle {
    font-size: 1rem;
  }
  
  .objectives-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .objective-card {
    padding: 1.25rem;
  }
  
  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .build-roadmap-button {
    width: 100%;
    max-width: 300px;
  }
}

@media (max-width: 480px) {
  .root {
    padding: 0.25rem;
  }
  
  .roadmap-header {
    padding: 1rem;
  }
  
  .roadmap-title {
    font-size: 1.75rem;
  }
  
  .frameworks-section,
  .timeline-section,
  .objectives-section,
  .confirmation-section {
    padding: 1rem;
  }
  
  .objective-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .objective-title {
    margin-right: 0;
  }
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-primary: #1f2937;
    --bg-secondary: #111827;
    --bg-tertiary: #374151;
    --text-primary: #f9fafb;
    --text-secondary: #d1d5db;
    --text-muted: #9ca3af;
    --icon-color: #9ca3af;
    --border-color: #374151;
    --border-light: #4b5563;
  }
  
  body {
    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  }
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--secondary-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--accent-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Objective/objectiveModal.css"],"names":[],"mappings":"AAAA,gDAAgD;;AAEhD,8CAA8C;;AAG9C,yCAAyC;AACzC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;EACnD,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,qEAAqE;EACrE,kEAAkE;EAClE,oEAAoE;AACtE;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;EACvF,gBAAgB;EAChB,0BAA0B;EAC1B,6DAA6D;EAC7D,iBAAiB;EACjB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,4BAA4B;EAC5B,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,qBAAqB;AACrB;EACE,iCAAiC;AACnC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;AACnC;;AAEA,2BAA2B;AAC3B;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sBAAsB;AACtB;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;EACzB;;EAEA;IACE,6DAA6D;EAC/D;AACF;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":["/* Modern Beautiful Design for Objective Modal */\r\n\r\n/* Import Google Fonts for better typography */\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\r\n\r\n/* CSS Variables for consistent theming */\r\n:root {\r\n  --primary-color: #F3903F;\r\n  --primary-light: #fbbf24;\r\n  --primary-dark: #d97706;\r\n  --secondary-color: #F3903F;\r\n  --accent-color: #F3903F;\r\n  --success-color: #10b981;\r\n  --warning-color: #f59e0b;\r\n  --error-color: #ef4444;\r\n  --info-color: #3b82f6;\r\n  --text-primary: #1e293b;\r\n  --text-secondary: #475569;\r\n  --text-muted: #64748b;\r\n  --icon-color: #64748b;\r\n  --bg-primary: #ffffff;\r\n  --bg-secondary: #f8fafc;\r\n  --bg-tertiary: #f1f5f9;\r\n  --border-color: #e2e8f0;\r\n  --border-light: #f1f5f9;\r\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\r\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\r\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\r\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n  --gradient-primary: linear-gradient(135deg, #F3903F 0%, #d97706 100%);\r\n  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #e67e22 100%);\r\n  --gradient-success: linear-gradient(135deg, #10b981 0%, #059669 100%);\r\n  --gradient-warning: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\r\n  --gradient-info: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\r\n  --gradient-danger: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\r\n}\r\n\r\n/* Global Styles */\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r\n  line-height: 1.6;\r\n  color: var(--text-primary);\r\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\r\n  min-height: 100vh;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.root {\r\n  margin-top: 80px;\r\n  padding: 1rem;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n/* Header Section */\r\n.roadmap-header {\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 2rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n  text-align: center;\r\n}\r\n\r\n.roadmap-header::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 4px;\r\n  background: var(--gradient-secondary);\r\n  opacity: 0.9;\r\n}\r\n\r\n.roadmap-title {\r\n  color: var(--text-primary);\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n  margin: 0 0 1rem 0;\r\n  background: var(--gradient-secondary);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.roadmap-subtitle {\r\n  color: var(--text-secondary);\r\n  font-size: 1.125rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Compliance Frameworks Section */\r\n.frameworks-section {\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.frameworks-section::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: var(--gradient-info);\r\n  opacity: 0.9;\r\n}\r\n\r\n.frameworks-title {\r\n  color: var(--text-primary);\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.frameworks-title::before {\r\n  content: '📋';\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.frameworks-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.framework-badge {\r\n  background: var(--gradient-info);\r\n  color: white;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 20px;\r\n  font-size: 0.875rem;\r\n  font-weight: 600;\r\n  border: none;\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.framework-badge:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n/* Timeline Section */\r\n.timeline-section {\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.timeline-section::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: var(--gradient-success);\r\n  opacity: 0.9;\r\n}\r\n\r\n.timeline-title {\r\n  color: var(--text-primary);\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.timeline-title::before {\r\n  content: '📅';\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.timeline-loading {\r\n  text-align: center;\r\n  padding: 3rem 1rem;\r\n}\r\n\r\n.timeline-spinner {\r\n  width: 48px;\r\n  height: 48px;\r\n  border: 3px solid rgba(31, 124, 80, 0.2);\r\n  border-top: 3px solid #1f7c50;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin: 0 auto 1rem;\r\n}\r\n\r\n.timeline-loading-text {\r\n  color: var(--text-secondary);\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n}\r\n\r\n/* Objectives Section */\r\n.objectives-section {\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.objectives-section::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: var(--gradient-warning);\r\n  opacity: 0.9;\r\n}\r\n\r\n.objectives-title {\r\n  color: var(--text-primary);\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.objectives-title::before {\r\n  content: '🎯';\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.objectives-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\r\n  gap: 1.5rem;\r\n  width: 100%;\r\n}\r\n\r\n/* Objective Card */\r\n.objective-card {\r\n  background: var(--bg-primary);\r\n  border-radius: 12px;\r\n  padding: 1.5rem;\r\n  border: 2px solid var(--border-light);\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.objective-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: var(--gradient-secondary);\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n}\r\n\r\n.objective-card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: var(--shadow-xl);\r\n  border-color: var(--secondary-color);\r\n}\r\n\r\n.objective-card:hover::before {\r\n  opacity: 1;\r\n}\r\n\r\n.objective-card.selected {\r\n  border-color: var(--success-color);\r\n  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);\r\n}\r\n\r\n.objective-card.selected::before {\r\n  background: var(--gradient-success);\r\n  opacity: 1;\r\n}\r\n\r\n.objective-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.objective-title {\r\n  color: var(--text-primary);\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  margin: 0;\r\n  line-height: 1.4;\r\n  flex: 1;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.priority-badge {\r\n  padding: 0.375rem 0.75rem;\r\n  border-radius: 20px;\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.priority-badge.high {\r\n  background: var(--gradient-danger);\r\n  color: white;\r\n}\r\n\r\n.priority-badge.medium {\r\n  background: var(--gradient-warning);\r\n  color: white;\r\n}\r\n\r\n.objective-description {\r\n  color: var(--text-secondary);\r\n  font-size: 0.875rem;\r\n  line-height: 1.6;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.objective-meta {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.meta-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.meta-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  opacity: 0.7;\r\n}\r\n\r\n.objective-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 1rem;\r\n  border-top: 1px solid var(--border-light);\r\n}\r\n\r\n.objective-reference {\r\n  color: var(--text-muted);\r\n  font-size: 0.75rem;\r\n  font-weight: 500;\r\n  max-width: 200px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.select-button {\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 8px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  border: 2px solid;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-decoration: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 80px;\r\n}\r\n\r\n.select-button.selected {\r\n  background: var(--gradient-success);\r\n  color: white;\r\n  border-color: var(--success-color);\r\n}\r\n\r\n.select-button.selected:hover {\r\n  transform: scale(1.05);\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.select-button:not(.selected) {\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  border-color: var(--border-color);\r\n}\r\n\r\n.select-button:not(.selected):hover {\r\n  background: var(--bg-secondary);\r\n  border-color: var(--secondary-color);\r\n  color: var(--secondary-color);\r\n}\r\n\r\n/* Confirmation Section */\r\n.confirmation-section {\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  margin-bottom: 2rem;\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--border-light);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.confirmation-section::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 3px;\r\n  background: var(--gradient-success);\r\n  opacity: 0.9;\r\n}\r\n\r\n.confirmation-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  cursor: pointer;\r\n  padding: 1rem;\r\n  border-radius: 8px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.confirmation-checkbox:hover {\r\n  background: var(--bg-secondary);\r\n}\r\n\r\n.confirmation-checkbox input[type=\"checkbox\"] {\r\n  width: 20px;\r\n  height: 20px;\r\n  accent-color: var(--success-color);\r\n  cursor: pointer;\r\n}\r\n\r\n.confirmation-checkbox label {\r\n  color: var(--text-primary);\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  margin: 0;\r\n}\r\n\r\n/* Action Buttons */\r\n.action-buttons {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.build-roadmap-button {\r\n  background: var(--gradient-success);\r\n  color: white;\r\n  border: none;\r\n  padding: 1rem 2rem;\r\n  border-radius: 12px;\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow: var(--shadow-md);\r\n  text-decoration: none;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  min-width: 200px;\r\n}\r\n\r\n.build-roadmap-button:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: var(--shadow-xl);\r\n  color: white;\r\n  text-decoration: none;\r\n}\r\n\r\n.build-roadmap-button::before {\r\n  content: '🚀';\r\n  font-size: 1.25rem;\r\n}\r\n\r\n/* Loading States */\r\n.loading-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 60vh;\r\n  gap: 2rem;\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 3rem;\r\n  box-shadow: var(--shadow-lg);\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 64px;\r\n  height: 64px;\r\n  border: 4px solid rgba(31, 124, 80, 0.2);\r\n  border-top: 4px solid #1f7c50;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  box-shadow: var(--shadow-md);\r\n}\r\n\r\n.loading-title {\r\n  color: var(--text-primary);\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  margin: 0 0 0.5rem 0;\r\n}\r\n\r\n.loading-subtitle {\r\n  color: var(--text-secondary);\r\n  font-size: 1.125rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n  max-width: 400px;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Empty State */\r\n.empty-state {\r\n  background: var(--bg-primary);\r\n  border-radius: 16px;\r\n  padding: 3rem 2rem;\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  border: 2px dashed var(--border-color);\r\n  width: 100%;\r\n  box-shadow: var(--shadow-sm);\r\n}\r\n\r\n.empty-icon {\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n  opacity: 0.5;\r\n}\r\n\r\n.empty-title {\r\n  color: var(--text-primary);\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.empty-description {\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  margin: 0;\r\n  max-width: 500px;\r\n  margin: 0 auto;\r\n  line-height: 1.6;\r\n}\r\n\r\n/* Animations */\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slideInLeft {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    transform: scale(1);\r\n  }\r\n  50% {\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n/* Apply animations */\r\n.roadmap-header {\r\n  animation: fadeInUp 0.6s ease-out;\r\n}\r\n\r\n.frameworks-section {\r\n  animation: slideInLeft 0.6s ease-out 0.1s both;\r\n}\r\n\r\n.timeline-section {\r\n  animation: slideInLeft 0.6s ease-out 0.2s both;\r\n}\r\n\r\n.objectives-section {\r\n  animation: slideInLeft 0.6s ease-out 0.3s both;\r\n}\r\n\r\n.confirmation-section {\r\n  animation: slideInLeft 0.6s ease-out 0.4s both;\r\n}\r\n\r\n.objective-card {\r\n  animation: fadeInUp 0.6s ease-out;\r\n}\r\n\r\n/* Enhanced Hover Effects */\r\n.objective-card:hover .priority-badge {\r\n  animation: pulse 0.6s ease-in-out;\r\n}\r\n\r\n.framework-badge:hover {\r\n  animation: pulse 0.6s ease-in-out;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .root {\r\n    margin-top: 60px;\r\n    padding: 0.5rem;\r\n  }\r\n  \r\n  .roadmap-header {\r\n    padding: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n  \r\n  .roadmap-title {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .roadmap-subtitle {\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  .objectives-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .objective-card {\r\n    padding: 1.25rem;\r\n  }\r\n  \r\n  .action-buttons {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n  \r\n  .build-roadmap-button {\r\n    width: 100%;\r\n    max-width: 300px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .root {\r\n    padding: 0.25rem;\r\n  }\r\n  \r\n  .roadmap-header {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .roadmap-title {\r\n    font-size: 1.75rem;\r\n  }\r\n  \r\n  .frameworks-section,\r\n  .timeline-section,\r\n  .objectives-section,\r\n  .confirmation-section {\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .objective-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.75rem;\r\n  }\r\n  \r\n  .objective-title {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n/* Dark mode support */\r\n@media (prefers-color-scheme: dark) {\r\n  :root {\r\n    --bg-primary: #1f2937;\r\n    --bg-secondary: #111827;\r\n    --bg-tertiary: #374151;\r\n    --text-primary: #f9fafb;\r\n    --text-secondary: #d1d5db;\r\n    --text-muted: #9ca3af;\r\n    --icon-color: #9ca3af;\r\n    --border-color: #374151;\r\n    --border-light: #4b5563;\r\n  }\r\n  \r\n  body {\r\n    background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\r\n  }\r\n}\r\n\r\n/* Custom scrollbar */\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: var(--bg-tertiary);\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--secondary-color);\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--accent-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
